import { render, staticRenderFns } from "./OperaDictWindow.vue?vue&type=template&id=15564168&"
import script from "./OperaDictWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDictWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports